module.exports = __webpack_public_path__ + "img/pageinteriors_03auditoria-en-seguros-03.12cdbad6.jpg";